<template>
  <div class="DataList">
    <div class="result">
      <div class="result_total">
   {{$t('DataSerch.Prefix')}}
        <span class="total">{{ total }}</span
        > {{$t('DataSerch.found')}}
      </div>
      <div class="sort">
        <div class="sortName">{{$t('DataSerch.sort')}}:</div>
        <div
          class="sort_class"
          @click="sort('')"
          :class="[sortVal == '' ? 'activeSort' : '']"
        >
          {{$t('DataSerch.defaultSort')}}
        </div>
        <div
          class="sort_class"
          @click="sort('visits')"
          :class="[sortVal == 'visits' ? 'activeSort' : '']"
        >
          {{$t('DataSerch.visits')}}
        </div>
        <div
          class="sort_class"
          @click="sort('downloads')"
          :class="[sortVal == 'downloads' ? 'activeSort' : '']"
        >
          {{$t('DataSerch.downloads')}}
        </div>
        <div
          class="sort_class"
          @click="sort('updateTime')"
          :class="[sortVal == 'updateTime' ? 'activeSort' : '']"
        >
          {{$t('DataSerch.lastUpdated')}}
        </div>
      </div>
    </div>
    <transition-group name="list" tag="div" class="DataList_box">
      <div
        class="DataList_SDGs list-item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDataInfo(item.dataId)"
      >
        <div class="DataList_SDGs_img">
          <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
        </div>
        <div class="DataList_SDGs_text">
          <div class="DataList_SDGs_text_content">
            <div class="title" v-html="item.productName"></div>
            <!--  $options.filters.formatTime(
                  item.introduction,
                  language,
                  400,
                  200
            )-->
            <div class="info" v-html="item.introduction"></div>
            <div class="other">
              <div class="other_num">
                <div class="date">
                  <i class="iconfont icon-riqi"></i>
                  <span>{{ item.createTime }}</span>
                </div>
                <div class="date">
                  <i class="iconfont icon-odbc"></i>
                  <span>{{ item.totalFile }}</span>
                </div>

                <div class="date">
                  <i class="iconfont icon-yanjing"></i>
                  <span>{{ item.visits }}</span>
                </div>
                <div class="date">
                  <i class="iconfont icon-xiazai1"></i>
                  <span>{{ item.downloads ? item.downloads : 0 }}</span>
                </div>
                <div class="date">
                  <i class="iconfont icon-weizhigeshi"></i>
                  <span>{{ item.dataFormat }}</span>
                </div>
              </div>
              <!-- <div class="collect">
                <div><i class="iconfont icon-shoucang6"></i>{{$t('DataSerch.Collected')}}</div>
              </div> -->
            </div>
            <div v-if="item.keywords" class="keywords">
              <div
                class="keywords_text"
                v-for="(v, k) in item.keywords.split(';')"
                :key="k"
              >
                {{ v }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <!-- loading -->
    <div v-if="dataList.length == 0 && loading != true" class="noData_">
      <img class="noData" src="@/assets/image/DataHub/noData.png" alt="" />
      <p>{{$t('DataSerch.noData')}}</p>
    </div>
    <!-- -->
    <div class="loading_box" style v-if="loading">
      <!-- loading -->
      <Loading></Loading>
    </div>

    <el-pagination
      class="pagination_box"
      v-show="dataList.length != 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { datasetList, getByPhrase } from "@/axios/datashare.js";
import { _throttle } from "@/util/public";
export default {
  name: "DataList",
  mixins: [mapMixin],
  data() {
    return {
      currentPage: 1,
      total: null,
      pageSize: 10,
      datasetType: null,
      dataList: [],
      scrollHeight: 0,
      moreShowBoolen: false,
      loading: false,
      filtersData: {},
      cacheSearchData: null,
      moreType: 2, //1为数据服务用户输入检索，2为其他检索
    };
  },
  components: {
    Loading: () => import("../../PublicComponents/NewLoading/NewLoading.vue"),
  },
  watch: {
    language() {
      //  this.getDatasetList();
    },
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("keywords")) {
      var keywords = this.$route.query.keywords;
      this.DatasetListFun({ keywords: { dataId: keywords } });
    }
    // goals筛选
    if (this.$route.query.hasOwnProperty("goals")) {
      var goals = this.$route.query.goals;
      this.DatasetListFun({ goals: { dataId: goals } });
    }
    if (this.$route.query.hasOwnProperty("searchKey")) {
      var searchKey = this.$route.query.searchKey;
      this.searchDataFun(searchKey);
    }
    bus.$on("SearchDataList", (res) => {
      this.dataList = [];
      this.loading = true;
      this.moreType = 1;
      this.currentPage = 1;
      this.searchDataFun(res);
    });
    // 进入页面参数搜索
    bus.$on("showDataList", (res) => {
      // 缓存搜索条件
      this.dataList = [];
      this.cacheSearchData = res;
      this.moreType = 2;
      this.currentPage = 1;
      this.DatasetListFun(res);
    });
  },
  methods: {
    searchDataFun(res) {
      this.searchVal = res;
      //
      this.getByPhraseDatasetList();
    },
    DatasetListFun(res) {
      this.fromatParamFun2(res); //格式化参数
      //
      this.getDatasetList();
    },
    scrollMore: _throttle(function () {
      this.currentPage++;
      if (this.moreType == 2) {
        //选择条件搜索+
        this.getDatasetList();
      } else {
        this.getByPhraseDatasetList(); // 输入框搜索
      }
    }, 1000),
    // 格式化参数2
    fromatParamFun2(res) {
      var str = "";
      for (let key in res) {
        if (res[key]) {
          if (res[key] instanceof Array) {
            if (res[key].length != 0) {
              var dataIdArr = [];
              for (var i = 0; i < res[key].length; i++) {
                dataIdArr.push(res[key][i].dataId);
              }
              str += `${key}=${dataIdArr.join()}&`;
            }
          } else {
            str += `${key}=${res[key].dataId}&`;
          }
        }
      }
      this.datasetType = str;
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(this.currentPage);
      if (this.moreType == 1) {
        // 搜索文件
        this.searchDataFun();
      } else {

        // 条件查询
        this.DatasetListFun(this.cacheSearchData);
      }
      console.log(`当前页: ${val}`);
    },
    //sort
    sort(val) {
      this.setSortVal(val);
    },
    // 关键字搜索
    async getByPhraseDatasetList() {
      var param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        phrase: this.searchVal?this.searchVal:'',
      };
      var res = await getByPhrase(param);
      setTimeout(() => {
        this.moreType = 1;
        this.total = res.data.data.total;
        this.dataList = res.data.data.list;
        this.loading = false;
        if (res.data.data.list.length < 10) {
          this.moreShowBoolen = false;
        } else {
          this.moreShowBoolen = true;
        }
      }, 1000);
      bus.$emit("SearchAccomplish");
    },
    async getDatasetList() {
      this.loading = true;
      var param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sort: this.sortVal,
      };
      if (this.datasetType) {
        param.datasetType = this.datasetType;
      }
      var res = await datasetList(param);
      setTimeout(() => {
        // this.dataList = []
        this.moreType = 2;
        this.dataList = res.data.data.list;
        this.total = res.data.data.total;
        this.loading = false;
        if (res.data.data.list.length < 10) {
          this.moreShowBoolen = false;
        } else {
          this.moreShowBoolen = true;
        }
      }, 1000);
    },
    toDataInfo(dataId) {
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
  },
  filters: {
    formatTime: function (value, language, zhNum, enNum) {
      // var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      // msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      // msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      var msg = value.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      msg = msg.replace(/\s+/g, " "); //去掉npsp
      // return msg.slice(0, zhNum).concat("......");
      if (language == "zh") {
        return msg.slice(0, zhNum);
      } else {
        if (msg.length > enNum) {
          return msg.slice(0, enNum);
        } else {
          return msg.slice(0, enNum);
        }
      }
    },
  },
};
</script>

<style  lang="scss" >
.hight-phrase {
  font-weight: 600;
  color: red !important;
}
@media screen and (min-width: 1026px) {
  .noData_ {
    padding: 10px 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .noData {
      margin-top: 30px;
      width: 200px;
      height: 193px;
    }
  }
  .loading_box {
    position: relative;
  }
  .pagination_box {
    width: 825px;
    margin: 30px auto;
    text-align: center;
  }
  .activeSort {
    color: #0a97d9 !important;
  }
  .sort_class:hover {
    color: #999;
    cursor: pointer;
  }
  .DataList {
    width: 865px;
    min-height: 200px;
    margin: 10px auto 0px;
    background: #fff;
    .result {
      padding: 10px 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 2px solid #f8f8f8;
      .result_total {
        font-size: 14px;
        color: #333;
        .total {
          color: rgba(0, 120, 212, 1);
        }
      }
      .sort {
        display: flex;
        font-size: 14px;
        color: #ccc;
        .sortName {
          color: #000;
        }
        div {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }

    .DataList_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 10px 0px 10px 20px;
      background: #fff;
      .DataList_SDGs {
        width: 100%;
        padding-right: 20px;
        cursor: pointer;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 10px 10px;
        border-bottom: 1px solid #f8f8f8;
        &:hover .DataList_SDGs_text {
          background: #f8f8f8;
          // opacity: .9;
        }
        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
        }
        // &:hover .other {
        //   color: #fff;
        // }
        // justify-content:;
        .DataList_SDGs_img {
          border: 1px solid #ebe9e9;
          width: 232px;
          height: 174px;
          border-radius: 8px;
          overflow: hidden;
          img {
            transition: 0.2s;
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .DataList_SDGs_text {
          // height: 230px;
          flex: 1;
          padding-left: 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          background: #fff;
          border-top: none;
          .DataList_SDGs_text_content{
            width: 100%;
            padding: 0 10px;
            .title {
              margin-top: 4px;
              font-size: 16px;
              color: rgba(10, 151, 217, 1);
              font-weight: 600;
              margin-bottom: 8px;
            }

            .info {
              font-size: 14px;
              color: rgba(51, 51, 51, 1);
              font-weight: 600;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; //多行在这里修改数字即可，这里显示3行
              -webkit-box-orient: vertical;
    word-break: break-all;
              // margin-bottom: 4px;
            }
            .other {
              width: 100%;
              margin-top: 10px;
              display: flex;
              flex-direction: row;
              align-items: center;
              color: #ccc;
              justify-content: space-between;
              .other_num {
                display: flex;
                flex-direction: row;

                .date {
                  font-size: 12px;
                  color: rgba(153, 153, 153, 1);
                  // font-weight: 600;
                  margin-right: 10px;
                  i {
                    margin-right: 6px;
                  }
                  span {
                    color: #000;
                    font-weight: 600;
                    margin-right: 12px;
                  }
                }
              }
              .collect {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                padding: 4px 6px;
                color: #fff;
                border-radius: 2px;
                background: rgba(18, 139, 237, 1);
                i {
                  margin-right: 4px;
                }
              }
            }
            .keywords {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin-top: 8px;
              .keywords_text {
                padding: 2px 10px;
                background: rgba(234, 234, 234, 1);
                color: rgba(102, 102, 102, 1);
                margin-right: 6px;
                font-size: 12px;
              }
            }
            .sdgs_img {
              display: flex;
              flex-direction: row;
              align-items: center;
              img {
                margin-left: 10px;
                border-radius: 4px;
                width: 34px;
                height: 34px;
              }
            }
          }
          .other {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            font-size: 16px;
            .key_img {
              border-radius: 2px;
              overflow: hidden;
            }
            .key_word {
              height: 40px;
              padding: 4px 10px;
              border-radius: 10px;
              // background: rgba(234, 234, 234, 1) !important;
              margin-right: 10px;
              font-size: 12px;
              color: #000;
              display: flex;
              align-items: center;
              color: #fff;
            }
          }
        }
      }
    }
    .tip:hover {
      opacity: 0.4px;
      transition: 0.2s;
    }
    .tip {
      cursor: pointer;
      margin: 20px auto 0;
      // box-shadow: 0px 2px 4px #ccc;
      border: 2px dashed #d8d8d8;
      // background: #fff;
      padding: 12px 36px;
      border-radius: 4px;
      width: fit-content;
      .text {
        color: #666;
        text-align: center;
        i {
          color: #666;
          font-size: 22px;
        }
      }
    }
    .no_data {
      width: fit-content;
      margin: 20px auto 0;
      color: #ccc;
      //  border: 2px dashed #d8d8d8;
      padding: 12px 36px;
      border-radius: 4px;
    }
  }
  .DataList_SDGs:hover .title,
  .DataList_SDGs:hover .info,
  .DataList_SDGs:hover .institution,
  // .DataList_SDGs:hover .date {
  //   color: #fff !important;
  // }
  // .DataList_SDGs:hover .other div {
  //   color: #fff !important;
  // }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .noData_ {
    padding: 10px 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .noData {
      margin-top: 30px;
      width: 200px;
      height: 193px;
    }
  }
  .loading_box {
    position: relative;
  }
  .pagination_box {
    width: 825px;
    margin: 30px auto;
    text-align: center;
  }
  .activeSort {
    color: #0a97d9 !important;
  }
  .sort_class:hover {
    color: #999;
    cursor: pointer;
  }
  .DataList {
    width: 865px;
    min-height: 200px;
    margin: 10px auto 0px;
    background: #fff;
    .result {
      padding: 10px 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 2px solid #f8f8f8;
      .result_total {
        font-size: 14px;
        color: #333;
        .total {
          color: rgba(0, 120, 212, 1);
        }
      }
      .sort {
        display: flex;
        font-size: 14px;
        color: #ccc;
        .sortName {
          color: #000;
        }
        div {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }

    .DataList_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 10px 0px 10px 20px;
      background: #fff;
      .DataList_SDGs {
        width: 100%;
        padding-right: 20px;
        cursor: pointer;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 10px 10px;
        border-bottom: 1px solid #f8f8f8;
        &:hover .DataList_SDGs_text {
          background: #f8f8f8;
          // opacity: .9;
        }
        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
        }
        // &:hover .other {
        //   color: #fff;
        // }
        // justify-content:;
        .DataList_SDGs_img {
          border: 1px solid #ebe9e9;
          width: 232px;
          height: 174px;
          border-radius: 8px;
          overflow: hidden;
          img {
            transition: 0.2s;
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .DataList_SDGs_text {
          // height: 230px;
          flex: 1;
          padding-left: 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          background: #fff;
          border-top: none;
          .DataList_SDGs_text_content {
            width: 100%;
            padding: 0 10px;
            .title {
              margin-top: 4px;
              font-size: 16px;
              color: rgba(10, 151, 217, 1);
              font-weight: 600;
              margin-bottom: 8px;
            }

            .info {
              font-size: 14px;
              color: rgba(51, 51, 51, 1);
              font-weight: 600;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; //多行在这里修改数字即可，这里显示3行
              -webkit-box-orient: vertical;
    word-break: break-all;
              // margin-bottom: 4px;
            }
            .other {
              width: 100%;
              margin-top: 10px;
              display: flex;
              flex-direction: row;
              align-items: center;
              color: #ccc;
              justify-content: space-between;
              .other_num {
                display: flex;
                flex-direction: row;

                .date {
                  font-size: 12px;
                  color: rgba(153, 153, 153, 1);
                  // font-weight: 600;
                  margin-right: 10px;
                  i {
                    margin-right: 6px;
                  }
                  span {
                    color: #000;
                    font-weight: 600;
                    margin-right: 12px;
                  }
                }
              }
              .collect {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                padding: 4px 6px;
                color: #fff;
                border-radius: 2px;
                background: rgba(18, 139, 237, 1);
                i {
                  margin-right: 4px;
                }
              }
            }
            .keywords {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin-top: 8px;
              .keywords_text {
                padding: 2px 10px;
                background: rgba(234, 234, 234, 1);
                color: rgba(102, 102, 102, 1);
                margin-right: 6px;
                font-size: 12px;
              }
            }
            .sdgs_img {
              display: flex;
              flex-direction: row;
              align-items: center;
              img {
                margin-left: 10px;
                border-radius: 4px;
                width: 34px;
                height: 34px;
              }
            }
          }
          .other {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            font-size: 16px;
            .key_img {
              border-radius: 2px;
              overflow: hidden;
            }
            .key_word {
              height: 40px;
              padding: 4px 10px;
              border-radius: 10px;
              // background: rgba(234, 234, 234, 1) !important;
              margin-right: 10px;
              font-size: 12px;
              color: #000;
              display: flex;
              align-items: center;
              color: #fff;
            }
          }
        }
      }
    }
    .tip:hover {
      opacity: 0.4px;
      transition: 0.2s;
    }
    .tip {
      cursor: pointer;
      margin: 20px auto 0;
      // box-shadow: 0px 2px 4px #ccc;
      border: 2px dashed #d8d8d8;
      // background: #fff;
      padding: 12px 36px;
      border-radius: 4px;
      width: fit-content;
      .text {
        color: #666;
        text-align: center;
        i {
          color: #666;
          font-size: 22px;
        }
      }
    }
    .no_data {
      width: fit-content;
      margin: 20px auto 0;
      color: #ccc;
      //  border: 2px dashed #d8d8d8;
      padding: 12px 36px;
      border-radius: 4px;
    }
  }
  .DataList_SDGs:hover .title,
  .DataList_SDGs:hover .info,
  .DataList_SDGs:hover .institution,
  // .DataList_SDGs:hover .date {
  //   color: #fff !important;
  // }
  // .DataList_SDGs:hover .other div {
  //   color: #fff !important;
  // }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (max-width: 767px) {
  .DataList {
    width: 100%;
    min-height: 200px;
    margin: 10px auto 0px;
    background: #fff;
    // background: #f8f8f8;
    .DataList_box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 10px;
      .DataList_SDGs {
        width: 100%;
        box-shadow: 0px 4px 5px rgb(187, 187, 187);
        // padding: 0 10px;
        margin-bottom: 4px;
        cursor: pointer;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .DataList_SDGs_img {
          width: 100%;
          height: 280px;
          overflow: hidden;
          img {
            transition: 0.2s;
            width: 100%;
            object-fit: cover;
            height: 100%;
          }
        }
        .DataList_SDGs_text {
          width: 800px;

          border-radius: 4px;
          // height: 230px;
          padding: 20px 10px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          background: #fff;
          // border-bottom: 1px solid #d8d8d8;
          border-top: none;
          .DataList_SDGs_text_content {
            .title {
              font-size: 16px;
              color: #000;
              font-weight: 600;
              margin-bottom: 8px;
            }
            .info {
              font-size: 14px;
              color: #333;
              margin-bottom: 10px;
                  word-break: break-all;
              // margin-bottom: 4px;
            }
            .institution,
            .date {
              font-size: 14px;
              color: #333;

              margin-bottom: 10px;
            }
            .sdgs_img {
              display: flex;
              flex-direction: row;
              align-items: center;
              img {
                margin-left: 10px;
                border-radius: 4px;
                width: 34px;
                height: 34px;
              }
            }
          }
          .other {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            font-size: 16px;
            .key_img {
              border-radius: 2px;
              overflow: hidden;
            }
            .key_word {
              height: 40px;
              padding: 4px 10px;
              border-radius: 10px;
              // background: rgba(234, 234, 234, 1) !important;
              margin-right: 10px;
              font-size: 12px;
              color: #000;
              display: flex;
              align-items: center;
              color: #fff;
            }
          }
        }
      }
    }
    .tip:hover {
      opacity: 0.4px;
      transition: 0.2s;
    }
    .tip {
      cursor: pointer;
      margin: 20px auto 0;
      // box-shadow: 0px 2px 4px #ccc;
      border: 2px dashed #d8d8d8;
      // background: #fff;
      padding: 12px 36px;
      border-radius: 4px;
      width: fit-content;
      .text {
        color: #666;
        text-align: center;
        i {
          color: #666;
          font-size: 22px;
        }
      }
    }
    .no_data {
      width: fit-content;
      margin: 20px auto 0;
      color: #ccc;
      //  border: 2px dashed #d8d8d8;
      padding: 12px 36px;
      border-radius: 4px;
    }
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>